// extracted by mini-css-extract-plugin
module.exports = {"SubscriptionForm":"SubscriptionForm_SubscriptionForm__civ6X","title":"SubscriptionForm_title__1Na2X","SubscriptionButton":"SubscriptionForm_SubscriptionButton__3ozen"};